import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Model from '@tripian/model';
import { api } from '@tripian/core';

import ICombinedState from '../redux/model/ICombinedState';
import { changeAlternatives, changeLoadingPlans, changePlans, saveError } from '../redux/action/trip';

const useStep = () => {
  const tripHash = useSelector((state: ICombinedState) => state.trip?.reference?.trip_hash);
  const dispatch = useDispatch();

  const stepAdd = useCallback(
    (planId: number, poiId: number): Promise<Model.Plan[]> => {
      dispatch(changeLoadingPlans(true));

      return api.combo
        .stepAdd(planId, poiId, tripHash || '')
        .then((trip: Model.Trip) => {
          dispatch(changePlans(trip.plans));
          return trip.plans;
        })

        .catch((stepAddError) => {
          dispatch(saveError('stepAdd', 'Add Place To Plan', stepAddError));
          throw stepAddError;
        })
        .finally(() => {
          dispatch(changeLoadingPlans(false));
        });
    },
    [dispatch, tripHash],
  );

  const stepReplace = useCallback(
    (stepId: number, alternativePoiId: number): Promise<Model.Plan[]> => {
      dispatch(changeLoadingPlans(true));

      return api.combo
        .stepReplace(stepId, alternativePoiId, tripHash || '')
        .then((trip: Model.Trip) => {
          dispatch(changeAlternatives(undefined));
          dispatch(changePlans(trip.plans));
          return trip.plans;
        })

        .catch((stepReplaceError) => {
          dispatch(saveError('stepReplace', 'Replace Place', stepReplaceError));
          throw stepReplaceError;
        })
        .finally(() => {
          dispatch(changeLoadingPlans(false));
        });
    },
    [dispatch, tripHash],
  );

  const stepDelete = useCallback(
    (stepId: number): Promise<Model.Plan[]> => {
      dispatch(changeLoadingPlans(true));

      return api.combo
        .stepDelete(stepId, tripHash || '')
        .then((trip: Model.Trip) => {
          dispatch(changeAlternatives(undefined));
          dispatch(changePlans(trip.plans));
          return trip.plans;
        })

        .catch((stepDeleteError) => {
          dispatch(saveError('stepDelete', 'Delete Place', stepDeleteError));
          throw stepDeleteError;
        })
        .finally(() => {
          dispatch(changeLoadingPlans(false));
        });
    },
    [dispatch, tripHash],
  );

  return { stepAdd, stepReplace, stepDelete };
};

export default useStep;
